import { PayloadAction, createSlice } from '@reduxjs/toolkit'
import {
  fetchAllTemplates,
  addTemplate,
  removeTemplate,
  updateTemplate,
} from '../actions/template.action'
import { Template, UpdateTemplateThunkParams } from '@dataTypes/index'

export type TemplateState = {
  data: Template[] | null
  loading: boolean
  error: null
}

const initialState: TemplateState = {
  data: null,
  loading: false,
  error: null,
}

const templatesSlice = createSlice({
  name: 'templates',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(
      fetchAllTemplates.fulfilled,
      (state, action: PayloadAction<Template[]>) => {
        state.data = action.payload
        state.loading = false
      },
    )
    builder.addCase(fetchAllTemplates.pending, (state) => {
      state.loading = true
    })
    builder.addCase(fetchAllTemplates.rejected, (state) => {
      state.error = null
      state.loading = false
    })

    builder.addCase(
      addTemplate.fulfilled,
      (state, action: PayloadAction<Template>) => {
        state.data = state.data
          ? [...state.data, action.payload]
          : [action.payload]
        state.loading = false
      },
    )
    builder.addCase(addTemplate.pending, (state) => {
      state.loading = true
    })
    builder.addCase(addTemplate.rejected, (state) => {
      state.error = null
      state.loading = false
    })

    builder.addCase(
      updateTemplate.fulfilled,
      (state, action: PayloadAction<UpdateTemplateThunkParams>) => {
        const { id, body: updatedTemplate } = action.payload
        if (!state.data) return
        const index = state.data.findIndex((item) => item.id === id)
        if (index !== -1) {
          state.data[index] = { ...state.data[index], ...updatedTemplate }
        }
        state.loading = false
      },
    )
    builder.addCase(updateTemplate.pending, (state) => {
      state.loading = true
    })
    builder.addCase(updateTemplate.rejected, (state) => {
      state.error = null
      state.loading = false
    })

    builder.addCase(removeTemplate.fulfilled, (state, action) => {
      const id = action.payload
      if (!state.data) return
      const index = state.data.findIndex((item) => item.id === id)
      if (index !== -1) {
        state.data && state.data.splice(index, 1)
      }
      state.loading = false
    })
    builder.addCase(removeTemplate.pending, (state) => {
      state.loading = true
    })
    builder.addCase(removeTemplate.rejected, (state) => {
      state.error = null
      state.loading = false
    })
  },
})

export default templatesSlice.reducer
